import { FC, HTMLAttributes } from "react";
import { useStyles } from "./RankCard.style";
import {
  Typography,
  Image,
  TypographyVariant,
  TypographyColor,
  Icon,
  Skeleton,
} from "@onmo/ui";
import Avatar from "../Avatar/Avatar";
import GemIcon from "../../../assets/icons/gem_1x.webp";
import GemIcon2x from "../../../assets/icons/gem_2x.webp";
import GemIcon3x from "../../../assets/icons/gem_3x.webp";
import clsx from "classnames";
import RankCardLoading from "./RankCardLoading";
import { useTranslation } from "react-i18next";

interface IRankCardProps {
  rank: number;
  username: string;
  avatar?: string;
  reward?: number | string;
  myRank?: boolean;
  rankState?: "up" | "down";
}

export const RankCard: FC<IRankCardProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const {
    avatar,
    username,
    rank,
    myRank,
    reward,
    rankState,
    className,
    ...otherProps
  } = props;
  const classes = useStyles();

  if (isNaN(rank)) return <RankCardLoading key={1} />;

  return (
    <div
      className={clsx(classes.root, `rank${rank}`, { myRank }, className)}
      {...otherProps}
    >
      <div className={clsx(classes.userContent, { myRank })}>
        <Avatar size={myRank ? "m" : "s"} url={avatar} />
        <div className={classes.content}>
          <div className={classes.rank}>
            <Typography
              variant={
                myRank
                  ? TypographyVariant.HeadingH6Bold
                  : TypographyVariant.HeadingH7Bold
              }
            >
              {"#" + rank}
              {rankState && (
                <Icon
                  name={rankState === "up" ? "icon-rank-up" : "icon-rank-down"}
                  size={16}
                  className={
                    rankState === "up"
                      ? classes.directionUp
                      : classes.directionDown
                  }
                />
              )}
            </Typography>
          </div>
          <Typography
            variant={
              myRank
                ? TypographyVariant.BodyB4Bold
                : TypographyVariant.BodyB5Regular
            }
            color={
              !reward && rank !== 1
                ? TypographyColor.Text2
                : TypographyColor.Text1
            }
            className={classes.username}
          >
            {username}
          </Typography>
        </div>
      </div>
      <div className={classes.reward}>
        {typeof reward === "number" && (
          <Image
            src={GemIcon}
            src2x={GemIcon2x}
            src3x={GemIcon3x}
            width={20}
            height={20}
          />
        )}
        <Typography
          variant={
            typeof reward === "number"
              ? TypographyVariant.BodyB5Bold
              : TypographyVariant.BodyB6Regular
          }
          lines={2}
        >
          {reward}
        </Typography>
      </div>
    </div>
  );
};

export default RankCard;
